import { getNow } from '@kathondvla/sri-client/date-utils';
import { GOVERNINGINSTITUTION } from 'ReduxLoop/constants';
import { settings } from 'Js/config/settings';
import { currentOuFetched } from 'ReduxLoop/ouManager/schoolManagerActions';
import { sriClient } from '../utils/apiConfig';

export const getOrganisationalUnit = (key) => {
  const ouPermalink = `/sam/organisationalunits/${key}`;
  return sriClient.get(ouPermalink);
};

export const getGoverningInstitutionOfOu = async (ou) => {
  const giRels = await sriClient.getAll('/sam/organisationalunits/relations', {
    to: ou.$$meta.permalink,
    type: 'GOVERNS',
    endDateAfter: getNow(),
    expand: 'results.from',
  });
  if (giRels.lenght === 0) {
    return {};
  }
  const governingInstitution = giRels[0].from.$$expanded;
  const mailContactDetails = await sriClient.getAll('/sam/organisationalunits/contactdetails', {
    organisationalUnit: governingInstitution.$$meta.permalink,
    type: 'MAIL',
  });
  return { governingInstitution, mailContactDetail: mailContactDetails[0] };
};

export const redirectToMijn1Team = async (ou, dispatch) => {
  if (ou.type === 'SCHOOL') {
    const vosSchool = await sriClient.get(`/schools/${ou.key}`);
    if (vosSchool.educationLevel === 'SECUNDAIR') {
      const canActAsRelations = await sriClient.getAll('/sam/organisationalunits/relations', {
        endDateAfter: getNow(),
        type: 'CAN_ACT_AS',
        to: ou.$$meta.permalink,
      });
      if (canActAsRelations.length === 1) {
        const se = await sriClient.get(canActAsRelations[0].from.href);
        console.log('Hallo Hallo Hallo! Er is maar 1 SE');
        dispatch(currentOuFetched(se));
      } else {
        console.log('Hallo Hallo Hallo! We gaan redirecten naar School Selecteer');
        window.location.href = '/#!/school/selecteer';
      }
    } else {
      console.log('Hallo Hallo Hallo! We gaan redirecten naar Mijn 1');
      window.location.href = `${settings.applications.mijn1}/#/team/${vosSchool.institutionNumber}`;
    }
  } else {
    const instNumber = (
      await sriClient.getAll('/sam/organisationalunits/externalidentifiers', {
        organisationalUnit: ou.$$meta.permalink,
        type: 'INSTITUTION_NUMBER',
      })
    )[0];
    console.log('Hallo Hallo Hallo! We gaan redirecten naar Mijn 1');
    window.location.href = `${settings.applications.mijn1}/#/team/${instNumber.value}`;
  }
};

const typesThatStillNeedToReferToVos = new Set([
  'SCHOOL',
  'BOARDING',
  'SCHOOLCOMMUNITY',
]);
const getPathForVosInsitution = async (institutionNumber) => {
  if (ou.type !== 'SCHOOL') {
    return ou.type === 'BOARDING' ? `/boardings/${institutionNumber}` : `/schoolcommunities/${institutionNumber}`;
  }
  const mainstructureEpds = await sriClient.getAll('/sam/educationalprogrammedetails', {
    hasMainstructure: true,
    organisationalUnit: institutionNumberObject.organisationalUnit.href,
    expand: 'results.mainstructure',
  });
  const mainstructures = mainstructureEpds.map((epd) => epd.mainstructure.$$expanded.code);
  if (mainstructures.contains(317) || mainstructures.contains(417) || mainstructures.contains(618)) {
    return `/cvos/${institutionNumber}`
  }
  return `/schools/${institutionNumber}`;
}
export const getVosEquivalent = async (ou) => {
  if (ou.$$meta.permalink.match(/\/kathondvla\/organisationalunits\//)) {
    return `/organisations/${ou.key}`;
  }
  if (!typesThatStillNeedToReferToVos.has(ou.type)) {
    return ou.$$meta.permalink;
  }
  const externalIdentifiers = await sriClient.getAll(
    '/sam/organisationalunits/externalidentifiers',
    {
      typeIn: 'INSTITUTION_NUMBER',
      organisationalUnit: ou.$$meta.permalink,
    }
  );
  const institutionNumber = externalIdentifiers[0];
  if (institutionNumber) {
    const path = await getPathForVosInsitution(institutionNumber.value);
    const vosOu = await sriClient.get(path);
    if (vosOu) {
      return vosOu.$$meta.permalink;
    }
  }
  console.warn(
    `Er is geen VOS equivalent gevonden voor ${ou.$$meta.permalink} van type ${ou.type}!!!!!`
  );
  return null;
};
